export const state = {
  ent_all: [],
  ent_waiting: [],
  ent_pro: [],
  ent_done: [],
  sort_pro: [],
  ent_paid: [],
  ent_handover: [],
  ent_view: {
    ent_status: {
      to_status_code: "",
    },
    categories:[],
  },
  next_Statuses: [],
  next_status: "",
  status_code: "",
  ent_timeline: [],
  ent_has_attorney: false,
  ent_has_application: false,
  ent_has_certificate: false,
  ent_detail: {
  },
  docCheckList: [],
  docAttached: [],
  docData: "",
  feeList: [],
  ent_timeline: [],
  ent_application: {
    created_at: new Date().toISOString(),
  },
  selected_fee: [],
  selected_cate: [],
  selected_cate_parent: [],
  entreaty: {
    action: {
      action_code: "",
      action_type: "",
      action_amount: 0,
    },
    maker: { name: "ຜູ້ຕາງໜ້າ", code: "01" },
    categories: [],
    action_code: "",
    action_type: "",
    company_name: "",
    tin: "",
  },
   ent_attorney: {
    version_no: 1,
    g_first_name: "",
    g_surname: "",
    g_age: 0,
    g_work: "",
    g_position: "",
    g_duty: "",
    g_home_no: "",
    g_group_no: "",
    g_address_id: 1,
    g_village: "",
    g_district: "",
    g_province: "",
    g_credit_type: "",
    g_credit_no: "",
    g_credit_start: "",
    g_credit_end: "",
    g_credit_by: "",
    g_place: "",
    g_tell: "",
    g_email: "",
    r_first_name: "",
    r_surname: "",
    r_age: null,
    r_work: "",
    r_position: "",
    r_duty: "",
    r_home_no: "",
    r_group_no: "",
    r_address_id: 1,
    r_village: "",
    r_district: "",
    r_province: "",
    r_credit_type: "",
    r_credit_no: "",
    r_credit_start: "",
    r_credit_end: "",
    r_credit_by: "",
    r_tell: "",
    r_email: "",
  },
};
